import { defineComponent, onMounted, onUnmounted } from 'vue';
import Budget from '@/presentation/components/campaign-settings/budget/budget.vue';
import Currency from '@/presentation/components/campaign-settings/currency/currency.vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import BudgetWrapperCode from '@/presentation/components/campaign-settings/budget-wrapper/budget-wrapper.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		Budget,
		Currency
	},
	setup: () => {
		const code = new BudgetWrapperCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			budgetTypeListing: code.budgetTypeListing,
			budgetTypeCustom: code.budgetTypeCustom,
			isLoading: code.isLoading,
			validationMessage: code.validationMessage,
			isListingFieldValidatedAndMissing: code.isListingFieldValidatedAndMissing,
			isListingFieldValidatedAndInvalid: code.isListingFieldValidatedAndInvalid,
			isCustomFieldValidatedAndMissing: code.isCustomFieldValidatedAndMissing,
			isCustomFieldValidatedAndInvalid: code.isCustomFieldValidatedAndInvalid,
			isListingBudgetFieldDisabled: code.isListingBudgetFieldDisabled,
			listingBudgetDisabledMessage: code.listingBudgetDisabledMessage,
			listingBudgetTooltipWrapper: code.listingBudgetTooltipWrapper,
			customProductsBudgetTooltipWrapper: code.customProductsBudgetTooltipWrapper
		};
	}
});
